import styled from 'astroturf/react';

import { Reader as ReaderBase } from 'js/social/Reader/Reader';

// NOTE(emily): I can't find a way to pass a prop named fullWidth to the inner
// <ReaderBase /> component while also using it as a dynamic prop here, so this
// has a funny name to distinguish it from the inner fullWidth prop.
const Reader = styled(ReaderBase)<{ fullWidthCoreX: boolean }>`
  @import 'stylesheets/design_system/_breakpoint.scss';

  &::backdrop {
    background: rgba(20, 20, 19, 0.5);
  }

  &:global(.ds2-5-modal) {
    border-radius: 0;

    &:not(.fullWidthCoreX) {
      @include breakpoint(medium) {
        border-radius: var(--border-radius-radius-md);
      }
      @include breakpoint(large) {
        border-radius: var(--border-radius-radius-md);
      }
    }
  }

  > :global(.ds2-5-modal__container) {
    padding: 0;

    > :global(.ds2-5-modal__header) {
      display: flex;
      padding: 40px
        var(--feed-in-line-viewer-top-section-padding-left-right, 16px) 32px
        var(--feed-in-line-viewer-top-section-padding-left-right, 16px);
      flex-direction: column;
      align-items: flex-start;
      align-self: stretch;
      background: var(--background-white, #fff);
      margin: 0;

      &:not(.fullWidthCoreX) {
        @include breakpoint(medium) {
          padding: 40px
            var(--feed-in-line-viewer-top-section-padding-left-right, 24px) 32px
            var(--feed-in-line-viewer-top-section-padding-left-right, 24px);
        }

        @include breakpoint(large) {
          padding: 40px
            var(--feed-in-line-viewer-top-section-padding-left-right, 56px) 32px
            var(--feed-in-line-viewer-top-section-padding-left-right, 56px);
        }
      }

      > :global(.ds2-5-modal__close-button) {
        padding: 0;
        right: 21px;
        top: 13px;
        width: 27px;
        height: 27px;
      }
    }
  }

  :global(#scribd-attachment-container) {
    padding: 16px;
    background: var(--brand-colors-neutral-300, #ebebee);
    min-height: 100%;

    @include breakpoint(medium) {
      padding: 24px 16px;
    }

    @include breakpoint(large) {
      padding: 40px 56px;
    }
  }
`;

export default Reader;
